/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IRentRewardAPIResponse {
  currentPoints: number;
  equivalentEarnings: number;
  level: number;
  levelName: string;
  totalEarnings: number;
  totalPointsAccumulated: number;
}

interface IDetailsData {
  status: string;
  image: string;
  detailsGroup: {
    title: string;
    value: string | number | null | undefined;
    key: any;
  }[];
}

interface IRentRewardState {
  rentRewardAPIResponse: IRentRewardAPIResponse;
  isShowRewardModal: boolean;
  activeRewardModal:
    | ''
    | 'rewardsDetailsModal'
    | 'rewardsErrorModal'
    | 'rewardsHistoryModal'
    | 'rewardsCartModal'
    | 'rewardsSuccessModal';
  rewardsDetailsData: IDetailsData;
  redeemError: { title: string; message: string };
  successCart: any;
}

const initialState: IRentRewardState = {
  rentRewardAPIResponse: {
    currentPoints: 0,
    equivalentEarnings: 0,
    level: 0,
    levelName: '',
    totalEarnings: 0,
    totalPointsAccumulated: 0
  },
  isShowRewardModal: false,
  activeRewardModal: '',
  rewardsDetailsData: { image: '', status: '', detailsGroup: [] },
  redeemError: { title: '', message: '' },
  successCart: null
};

export const rewardSlice = createSlice({
  name: 'reward',
  initialState,
  reducers: {
    setRentRewardAPIResponse: (
      state: IRentRewardState,
      action: PayloadAction<IRentRewardAPIResponse>
    ) => {
      const { payload } = action;
      state.rentRewardAPIResponse = payload;
    },
    setIsShowRewardModal: (state: IRentRewardState, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.isShowRewardModal = payload;
    },
    setActiveRewardModal: (
      state: IRentRewardState,
      action: PayloadAction<
        | ''
        | 'rewardsDetailsModal'
        | 'rewardsErrorModal'
        | 'rewardsHistoryModal'
        | 'rewardsCartModal'
        | 'rewardsSuccessModal'
      >
    ) => {
      const { payload } = action;
      state.activeRewardModal = payload;
    },
    setRewardsDetailsData: (state: IRentRewardState, action: PayloadAction<IDetailsData>) => {
      const { payload } = action;
      state.rewardsDetailsData = payload;
    },
    setRedeemError: (
      state: IRentRewardState,
      action: PayloadAction<{ title: string; message: string }>
    ) => {
      const { payload } = action;
      state.redeemError = payload;
    },
    setSuccessCart: (state: IRentRewardState, action: PayloadAction<any>) => {
      const { payload } = action;
      state.successCart = payload;
    }
  }
});

const { actions, reducer } = rewardSlice;

export const {
  setRentRewardAPIResponse,
  setIsShowRewardModal,
  setActiveRewardModal,
  setRewardsDetailsData,
  setRedeemError,
  setSuccessCart
} = actions;

export default reducer;
